import { createBotConversation } from 'api/conversation'
import store from 'config/store'
import { clearActiveCampaign } from 'modules/campaigns/actions'
import { clearActiveConversation,setActiveDriftlink, setHasForcedConversation } from 'modules/conversations/actions'
import { getEmbedLocale } from 'modules/embed/utils'
import { toggleChat } from 'modules/view/actions'
import { pathOr } from 'ramda'
import { EmbedConfiguration } from 'types/embed'
import { MessageAttributes } from 'types/message'
import { log, toLowerCaseKeyedObject } from 'utils'
import { requestKillAnnouncementFrames } from 'utils/frames'

const DEFAULT_DRIFTLINK_ATTRIBUTES : Partial<MessageAttributes> = {
  isFromConversationalLandingPage: false
}

/**
 * Handles the lookup for any driftlink interaction ids in the embed that matches the location hash in the URL
 * @param hash - The location hash from the URL (ex. test.com/#testing)
 */
export const fireByDriftlink = async (hash: string) => {
  const { interactionSlugMap = {}, interactionTestingSlugMap = {} } = pathOr<Partial<EmbedConfiguration>>({}, ['embed', 'configuration'], store.getState())
  const slug: string = hash ? hash.substring(1).toLowerCase() : null

  if(!slug) {
    return false
  }

  const lowercasedTestingSlugMap = toLowerCaseKeyedObject(interactionTestingSlugMap)
  if (lowercasedTestingSlugMap[slug]) {
    await activateDriftLink(hash, lowercasedTestingSlugMap[slug], {
      ...DEFAULT_DRIFTLINK_ATTRIBUTES,
      isTestingConversation: true
    })

    return true
  }

  const lowercasedSlugMap = toLowerCaseKeyedObject(interactionSlugMap)
  if (lowercasedSlugMap[slug]) {
    await activateDriftLink(hash, lowercasedSlugMap[slug], DEFAULT_DRIFTLINK_ATTRIBUTES)
    return true
  }

  return false
}

/**
 * Responsible for creating the bot conversation and telling our redux state that this is our new active conversation
 * Exported only for testing
 * @param hash - The location hash from the URL (ex. test.com/#testing)
 * @param interactionId - The interaction ID that points to a bot playbook to be fired
 * @param attributes - Any message attributes that need to be attached to a Driftlink started conversation
 */
export const activateDriftLink = async (hash: string, interactionId: number, attributes : Partial<MessageAttributes>) => {
  const locale = getEmbedLocale()
  try {
    store.dispatch(setActiveDriftlink(hash))
    store.dispatch(toggleChat({ chatOpen: false }))
    store.dispatch(setHasForcedConversation())
    store.dispatch(clearActiveCampaign())
    store.dispatch(clearActiveConversation())

    await requestKillAnnouncementFrames()
    await createBotConversation(interactionId, { ...attributes, locale, goToConversation: true })
  } catch (err) {
    log({ data: [`Failed to activate drift link ${hash}:${interactionId}`, err] })
  }
}
